import { authRequest } from "../utils/netRequest";

export class AuthService {
  async subscribe(fcmToken) {
    return await authRequest({
      url: "/push/subscribe",
      method: "post",
      data: {
        fcmToken,
      },
    });
  }
}

export default new AuthService();


